import React from 'react';

const UpdateUserData = React.createContext();

export default UpdateUserData;
